/** Remove acentos, espaços extra e passa a minúsculas para comparar respostas. */
export function normalizeAnswer(value) {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}

function nearMissList(nearMisses = []) {
  return nearMisses.map((item) =>
    typeof item === 'string'
      ? { value: item, hint: 'Precisa de algo mais…' }
      : { value: item.value, hint: item.hint || 'Precisa de algo mais…' },
  );
}

/**
 * @returns {{ status: 'correct' | 'near' | 'wrong', message: string }}
 */
export function checkAnswer(input, answer, acceptedAnswers = [], nearMisses = []) {
  const normalized = normalizeAnswer(input);
  if (!normalized) {
    return { status: 'wrong', message: 'Tenta novamente!' };
  }

  const correctSet = [answer, ...acceptedAnswers].map(normalizeAnswer);
  if (correctSet.includes(normalized)) {
    return { status: 'correct', message: 'Bom trabalho!' };
  }

  const nears = nearMissList(nearMisses);
  for (const near of nears) {
    if (normalizeAnswer(near.value) === normalized) {
      return { status: 'near', message: near.hint };
    }
  }

  // Quase: input longo contido na resposta (ou o inverso)
  if (normalized.length >= 4) {
    for (const c of correctSet) {
      if (c.includes(normalized) || normalized.includes(c)) {
        return { status: 'near', message: 'Precisa de algo mais…' };
      }
    }
  }

  // Frase longa que contém a resposta correcta → near genérico
  for (const c of correctSet) {
    if (c.length >= 3 && normalized.includes(c) && normalized !== c) {
      const specific = nears.find((n) => normalizeAnswer(n.value).includes(c));
      return {
        status: 'near',
        message: specific?.hint || 'Precisa de algo mais…',
      };
    }
  }

  return { status: 'wrong', message: 'Tenta novamente!' };
}

/**
 * Valida vários campos (ex.: local / objeto / culpado).
 * @returns {{ status: 'correct' | 'near' | 'wrong', message: string }}
 */
export function checkMultiAnswer(values, fields) {
  const results = fields.map((field) =>
    checkAnswer(
      values[field.id] ?? '',
      field.answer,
      field.acceptedAnswers || [],
      field.nearMisses || [],
    ),
  );

  if (results.every((r) => r.status === 'correct')) {
    return { status: 'correct', message: 'Bom trabalho!' };
  }

  const filled = fields.every((f) => normalizeAnswer(values[f.id] ?? ''));
  if (!filled) {
    return { status: 'wrong', message: 'Preenche os três espaços.' };
  }

  const near = results.find((r) => r.status === 'near');
  if (near) {
    return { status: 'near', message: near.message };
  }

  const correctCount = results.filter((r) => r.status === 'correct').length;
  if (correctCount > 0) {
    return { status: 'near', message: 'Precisa de algo mais…' };
  }

  return { status: 'wrong', message: 'Tenta novamente!' };
}
